<template>
  <div v-if="rows.length > 0" class="preview-table">
    <table class="preview-table__table">
      <thead>
        <tr>
          <th class="preview-table__status"></th>
          <th v-for="header in headers" :key="header">{{ header }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in rows" :key="index" :class="rowClass(row)">
          <td class="preview-table__status">
            <span v-if="row.valid" class="preview-table__status--ok">&#10003;</span>
            <sp-tooltip v-else-if="row.existing" position="right" theme="dark" content="Already registered">
              <span class="preview-table__status--existing">&#9888;</span>
            </sp-tooltip>
            <sp-tooltip v-else position="right" theme="dark" :content="rowErrorText(row)">
              <span class="preview-table__status--error">&#10007;</span>
            </sp-tooltip>
          </td>
          <td v-for="header in headers" :key="header">{{ row.values[header] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup>
defineProps({
  headers: {
    type: Array,
    default: () => [],
  },
  rows: {
    type: Array,
    default: () => [],
  },
});

function rowClass(row) {
  if (row.existing) {
    return "preview-table__row--existing";
  }

  if (!row.valid) {
    return "preview-table__row--error";
  }

  return "";
}

function rowErrorText(row) {
  return row.errors?.join(", ") || "Invalid entry";
}
</script>

<style scoped lang="scss">
.preview-table {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  border: var(--sp-ref-spacing-px) solid var(--sp-sys-color-outline-variant, #f9f9f9);
  border-radius: var(--sp-ref-spacing-2);

  &__table {
    width: 100%;
    border-collapse: collapse;
    font-size: var(--sp-sys-typescale-small-font-size, 0.875rem);

    th,
    td {
      padding: var(--sp-ref-spacing-4);
      text-align: left;
      border-bottom: var(--sp-ref-spacing-px) solid var(--sp-sys-color-outline-variant, #f9f9f9);
    }

    th {
      font-size: var(--sp-ref-font-size-small, 0.625rem);
      font-weight: var(--sp-ref-font-weight-normal, 400);
      letter-spacing: calc(var(--sp-ref-spacing-px) * 0.5);
      color: var(--sp-sys-color-on-surface-variant, #4a4a4a);
      position: sticky;
      top: 0;
    }

    tbody tr:last-child td {
      border-bottom: none;
    }

    tbody tr:nth-child(even) {
      background-color: var(--sp-sys-color-surface-variant, #f9f9f9);
    }
  }

  &__status {
    width: 2rem;
    text-align: center;

    &--ok {
      color: var(--sp-sys-color-success, #2e7d32);
    }

    &--existing {
      color: var(--sp-sys-color-warning, #f57c00);
    }

    &--error {
      color: var(--sp-sys-color-error, #d32f2f);
    }
  }
}
</style>
